import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_CAREGIVER_DETAILS } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetCaregiverDetailsPayload, GetCaregiverDetailsResult } from '../types/getCaregiverDetails.types';

export const getCaregiversDetails = (builder: BuilderType) =>
  builder.query<GetCaregiverDetailsResult, GetCaregiverDetailsPayload>({
    query: (data) => ({
      data,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: GET_CAREGIVER_DETAILS,
    }),
    transformResponse: (response: GenericApiResponse<GetCaregiverDetailsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
